<template>
  <div class="approve-modal">
    <b-modal
      ref="approve-modal"
      size="lg"
      hide-footer
      title="Duyệt yêu cầu"
      id="approve-modal"
    >
      <b-row>
        <b-col cols="12">
          <b-form-group label="Ghi chú:">
            <b-form-textarea
              v-model="note"
              placeholder="Nhập ghi chú"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12" class="text-right">
          <b-button
            variant="primary"
            size="sm"
            @click="onApprove"
            :disabled="isSubmitting"
          >
            <span
              v-if="isSubmitting"
              class="spinner-border spinner-border-sm mr-1"
              role="status"
              aria-hidden="true"
            ></span>
            Duyệt
          </b-button>
          <b-button
            variant="secondary"
            size="sm"
            @click="hideModal"
            :disabled="isSubmitting"
            style="margin-left: 10px"
          >
            Hủy
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { makeToastSuccess, makeToastFaile } from '@/utils/common';

export default {
  name: 'ApproveModal',
  data() {
    return {
      approvalId: null,
      note: '',
      isSubmitting: false,
    };
  },
  methods: {
    /**
     * Show the modal
     * @param {string|number} approvalId - The ID of the approval to approve
     */
    showModal(approvalId) {
      this.approvalId = approvalId;
      this.note = '';
      this.$refs['approve-modal'].show();
    },

    /**
     * Hide the modal
     */
    hideModal() {
      this.$refs['approve-modal'].hide();
    },

    /**
     * Handle approve button click
     */
    async onApprove() {
      if (!this.approvalId) {
        makeToastFaile('Không tìm thấy ID phiếu duyệt chi');
        return;
      }

      this.isSubmitting = true;

      try {
        const response = await ApiService.put(`v1/approvals/approve`, {
          id: this.approvalId,
          note: this.note,
          step: 1,
        });

        if (response.data.status === 200) {
          makeToastSuccess(response.data.message);
          this.hideModal();
          this.$emit('submit-data-success');
        } else {
          makeToastFaile(response.data.message);
        }
      } catch (error) {
        console.error('Error approving request:', error);
        const message =
          error.response?.data?.message || 'Lỗi khi duyệt yêu cầu';
        makeToastFaile(message);
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.approve-modal {
  // Additional styling if needed
}
</style>
